export default "__VITE_ASSET__dqa$DGIf__"